import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Loader from '../../../Loading';
import QUERY_TYPES, { QUERY_TYPE_MAP } from '../QueryTypes/queryTypeRegistry';





const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: 120,
    }
}));

export default function AddQueryModal(props) {
    const [loading, setLoading] = useState(false)
    const [formState, setFormState] = useState({});
    const [queryParameters, setQueryParameters] = useState({});
    const [editMode, setEditMode] = useState(false);

    const classes = useStyles();

    const handleChange = ({ target }) => {
        const { name, value } = target;
        handleUpdateState(name, value);
    };

    const handleChangeCheckbox = ({ target }) => {
        const { name, checked } = target;
        var value;
        if (checked) {
            value = 1
        } else {
            value = 0
        }
        handleUpdateState(name, value);
    };

    function handleUpdateState(name, value) {
        if (["query_type", "sql", "title", "status"].includes(name)) {
            setFormState((prev) => ({
                ...prev,
                [name]: value
            }));
        } else {
            setQueryParameters((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    }

    const resetValues = () => {
        setFormState({})
        setQueryParameters({})
        setLoading(false)
    }

    const handleClose = () => {
        resetValues();
        props.closeAddQueryModal();
    }
    const handleDelete = () => {
        props.deleteQuery(props.query._id.$oid);
    }
    const handleSubmitForm = (event) => {
        event.preventDefault();
        setLoading(true)
        if (editMode) {
            props.updateQuery(props.query._id.$oid, formState, queryParameters);
        } else {
            props.createQuery(formState, queryParameters);
        }
    }

    const queryOptions = () => {
        return QUERY_TYPES.map((type, index) =>
            <option key={index} value={type.value}>{type.text}</option>
        );
    }

    function handleShow() {
        if (Object.keys(props.query).length === 0) {
            setEditMode(false)
            const evt = { target: { name: "status", checked: true } }
            handleChangeCheckbox(evt)
        } else {
            setEditMode(true)
            handleUpdateState("query_type", props.query.query_type)
            handleUpdateState("status", props.query.status)
            handleUpdateState("title", props.query.title)
            handleUpdateState("sql", props.query.sql)
            var value;
            for (value in props.query.values) {
                handleUpdateState(value, props.query.values[value])
            }
        }
    }

    return (
        <Modal
            show={props.show}
            onHide={handleClose}
            onExited={resetValues}
            backdrop="static"
            size="lg"
            keyboard={false}
            onShow={handleShow}
        >
            <Modal.Header>
                {editMode ?
                    <Modal.Title>Edit Validation Widget</Modal.Title> :
                    <Modal.Title>Add Validation Widget</Modal.Title>
                }
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmitForm}>
                    <Row>
                        <Col>
                            <InputLabel id="widget-type-label" required>Widget Type</InputLabel>
                            <Select
                                native
                                labelId="widget-type-label"
                                id="query_type"
                                name="query_type"
                                value={formState.query_type}
                                onChange={handleChange}
                                fullWidth
                                required
                            >
                                <option aria-label="None" />
                                {queryOptions()}
                            </Select>
                        </Col>
                    </Row>
                    <hr />
                    {formState.query_type != undefined && formState.query_type.length > 1 ?
                        <Row>
                            <Col>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="title"
                                    label="Title"
                                    key="title"
                                    name="title"
                                    onChange={handleChange}
                                    helperText="This will show up as the header of the widget"
                                    value={formState.title}
                                />
                            </Col>
                        </Row> : null
                    }
                    <br />
                    {(() => {
                        const SelectedQueryType = QUERY_TYPE_MAP[formState.query_type];
                        return SelectedQueryType
                            ? <SelectedQueryType
                                handleChange={handleChange}
                                handleChangeCheckbox={handleChangeCheckbox}
                                queryParameters={queryParameters}
                                sql={formState.sql}
                            />
                            : null;
                    })()}
                    <Modal.Footer>
                        {loading ? <Loader /> :
                            <>
                                {editMode && formState.status === 0 ?
                                    <Button variant="outlined" color="secondary" onClick={handleDelete} className="mr-3">Delete Widget</Button> :
                                    null
                                }
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={formState.status === 1}
                                            onChange={handleChangeCheckbox}
                                            name="status"
                                            color="primary"
                                        />
                                    }
                                    label="Enabled"
                                />
                                <Button variant="contained" color="info" onClick={handleClose} className="mr-3">Close</Button>
                                <Button variant="contained" color="primary" type="submit">{editMode ? "Save Changes" : "Create Widget"}</Button>
                            </>
                        }

                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
}